import { gql } from '@apollo/client';

import { USE_CONTENT_PREVIEW_FILTER } from 'constants/query';
import { COMPONENT_FRAGMENTS, MODULE_FRAGMENTS } from 'queries/fragments';
import { FRAGMENTS } from './navigation';

const getDetailFilter = USE_CONTENT_PREVIEW_FILTER
  ? `{
          OR: [
            { slug: $pageSlug, navigationTag: { slug: $tagSlug } }
            { slug: $pageSlug, navigationTag: { sys: { id: $tagSlug } } }
          ]
        }`
  : `{ slug: $pageSlug, navigationTag: { slug: $tagSlug } }`;

// Note that while dynamic landing pages do not have field-level localization, we must pass $locale to gql for curated list to work correctly.
// A curated list can contain a global detail page, which requires $locale.
const PAGE_DETAIL_GLOBAL_TRENDS_QUERY = {
  body: ({
    collection = 'pageDynamicLandingCollection',
    filter = getDetailFilter,
  }) => gql`
    query DynamicLandingPage(
      $preview: Boolean = false
      $tagSlug: String!
      $pageSlug: String!
      $locale: String!
    ) {
      ${collection}(
        preview: $preview
        where: ${filter}
        locale: $locale
        limit: 1
      ) {
        items {
          meta {
            ...MetaFields
          }
          hero {
            ...HeroFields
          }
          navigationTag {
            title
          }
          slug
          backgroundColor
          showCultureNextAnalyzer
          showGenAiAudioTool
          lowerNavigation {
            slug
            navigationItemsCollection {
              items {
                type: __typename
                ... on NavigationTag {
                  ...NavigationTag
                }
                ... on Dropdown {
                  ...Dropdown
                }
              }
            }
          }
        }
      }
    }
    ${COMPONENT_FRAGMENTS.IMAGE}
    ${COMPONENT_FRAGMENTS.META}
    ${COMPONENT_FRAGMENTS.CTA}
    ${COMPONENT_FRAGMENTS.HERO}
    ${FRAGMENTS.NAVIGATION_TAG}
    ${FRAGMENTS.LINK}
    ${FRAGMENTS.DROPDOWN}
  `,
  modules: ({
    collection = 'pageDynamicLandingCollection',
    filter = getDetailFilter,
  }) => gql`
    query GlobalDetailPage(
      $preview: Boolean = false
      $tagSlug: String!
      $pageSlug: String!
      $locale: String!
    ) {
      ${collection}(
        preview: $preview
        where: ${filter}
        locale: $locale
        limit: 1
      ) {
        items {
          modulesCollection {
            items {
              ... on ModuleTrendGrid {
                ...TrendGrid
              }
              ... on ModuleSpotifyPlayer {
                ...SpotifyPlayer
              }
              ... on ModuleTaggedContentGroup {
                ...TaggedContentGroup
              }
              ... on ModuleJumpLinkGroup {
                ...JumpLinkGroup
              }
              ... on ModuleFeatureCardContainer {
                ...FeatureCardContainer
              }
              ... on ModuleVideoFeatureCard {
                ...VideoFeatureCard
              }
              ... on ModuleTileCarousel {
                ...TileCarousel
              }
              ... on ModuleSplitView {
                ...SplitView
              }
            }
          }
        }
      }
    }
    ${COMPONENT_FRAGMENTS.CTA}
    ${COMPONENT_FRAGMENTS.IMAGE}
    ${COMPONENT_FRAGMENTS.CONTENT_TILE}
    ${COMPONENT_FRAGMENTS.CTA_CARD}
    ${COMPONENT_FRAGMENTS.STAT_CARD}
    ${MODULE_FRAGMENTS.TREND_GRID}
    ${MODULE_FRAGMENTS.SPOTIFY_PLAYER}
    ${MODULE_FRAGMENTS.JUMP_LINK_GROUP}
    ${MODULE_FRAGMENTS.FEATURE_CARD_CONTAINER}
    ${MODULE_FRAGMENTS.FEATURE_CARD_WITH_FORM}
    ${MODULE_FRAGMENTS.INLINE_FORM}
    ${MODULE_FRAGMENTS.TAGGED_CONTENT_GROUP}
    ${MODULE_FRAGMENTS.VIDEO_FEATURE_CARD}
    ${MODULE_FRAGMENTS.TILE_CAROUSEL}
    ${MODULE_FRAGMENTS.MARKDOWN_TEXT}
    ${MODULE_FRAGMENTS.ACCORDION}
    ${MODULE_FRAGMENTS.LIST}
    ${COMPONENT_FRAGMENTS.LIST_ITEM}
    ${MODULE_FRAGMENTS.QUOTE}
    ${MODULE_FRAGMENTS.SPLIT_VIEW}
  `,
};

export default PAGE_DETAIL_GLOBAL_TRENDS_QUERY;
